import { generateAddress } from "./ExperimentSearchUtil.js";
import experimentSearchConstants from "./ExperimentSearchConstants.js";
class ExperimentSearchActions {
  getAllExps(searchQuery, fromDate, toDate, workspaceId, managementGroup, isolationGroup, trafficFilters) {
    const address = generateAddress({
      searchQuery,
      fromDate,
      toDate,
      workspaceId,
      managementGroup,
      isolationGroup,
      trafficFilters
    });
    return {
      type: experimentSearchConstants.LOAD_EXP_SEARCH,
      payload: address,
      workspaceId,
      managementGroup,
      isolationGroup,
      trafficFilters
    };
  }
  updateSelectedValues(managementGroup, isolationGroup, trafficFilters) {
    return {
      type: experimentSearchConstants.UPDATE_SELECTED_VALUES,
      managementGroup,
      isolationGroup,
      trafficFilters
    };
  }
  fetchScorecardsAction(payload) {
    return {
      type: experimentSearchConstants.FETCH_SCORE_CARDS,
      payload
    };
  }
  getAllScoreCardsAction(payload) {
    return {
      type: experimentSearchConstants.GET_ALL_SCORECARDS,
      payload
    };
  }
  getAllExpsAction(payload) {
    return {
      type: experimentSearchConstants.GET_ALL_EXPS,
      payload
    };
  }
  loadManagementGroups(payload) {
    return {
      type: experimentSearchConstants.LOAD_MGMT_GRP,
      payload
    };
  }
  updateMgmtGroupData(payload) {
    return {
      type: experimentSearchConstants.UPDATE_MGMT_GROUPS,
      payload
    };
  }
  loadIsolationGroups(payload) {
    return {
      type: experimentSearchConstants.LOAD_ISOLATION_GROUPS,
      payload
    };
  }
  updateIsolationGroupsData(payload) {
    return {
      type: experimentSearchConstants.UPDATE_ISOLATION_GROUPS,
      payload
    };
  }
  loadOtherSearchFields(payload) {
    return {
      type: experimentSearchConstants.LOAD_OTHER_SEARCH_FIELDS,
      payload
    };
  }
  updateOtherSearchFieldsData(payload, managementGroup, workspaceId) {
    return {
      type: experimentSearchConstants.UPDATE_OTHER_SEARCH_FIELDS,
      payload,
      managementGroup,
      workspaceId
    };
  }
  loadSubMgmtGroupData(payload) {
    return {
      type: experimentSearchConstants.LOAD_SUB_MGMT_GRPS,
      payload
    };
  }
  updateSubMgmtGrpsData(payload) {
    return {
      type: experimentSearchConstants.UPDATE_SUB_MGMT_GRPS,
      payload
    };
  }
  handleSubMgmtState(payload) {
    return {
      type: experimentSearchConstants.HANDLE_SUB_MGMT_STATE,
      payload
    };
  }
  fetchStatusAction(payload) {
    return {
      type: experimentSearchConstants.LOAD_STATUS_DATA,
      payload
    };
  }
  updateStatusData(payload) {
    return {
      type: experimentSearchConstants.UPDATE_STATUS_DATA,
      payload
    };
  }
}
const ExperimentSearchActions$1 = new ExperimentSearchActions();
export {
  ExperimentSearchActions,
  ExperimentSearchActions$1 as default
};
//# sourceMappingURL=ExperimentSearchActions.js.map
